import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import Modal from '../../../Util/Modal/CustomModal';
import Fetch from '../../../../../util/core/Fetch';
import CustomCheckBox from "../../Form/CustomInputs/CustomCheckBox";
import Toast from '../../../Util/Toast/Toast';
import ReactTooltip from "react-tooltip";
import { useSelector, useDispatch } from 'react-redux';
import CustomForm from '../../../Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../Util/Form/CustomForm/CustomFormContainer';
import DataTable from 'react-data-table-component';
import styled from 'styled-components';
import sleep from 'sleep-promise'
import EditableInput from '../../Form/CustomInputs/EditableInput';
import useSessionFilters from '../hooks/useSessionFilters';
import moment from "moment";

import config from "../../../../../../application/config/config";

import { VerifyPermission } from "../../../../../util/core/VerifyPermission";

import './CustomList.css';
import CustomTab from "./CustomTab";
import CustomListButton from "../../Form/CustomInputs/CustomListButton";
import CustomTooltipColumn from "../../Form/CustomForm/CustomTooltipColumn";
import RowSelect from "../../Form/CustomInputs/RowSelect";
import { truncate } from "../../../../../util/core/TruncateText";
const TextField = styled.input``;

const FilterComponent = ({ filterText, onFilter, onClear }) => (
  <>
    <TextField
      id="search"
      type="text"
      placeholder="Pesquisa"
      aria-label="Search Input"
      value={filterText}
      onChange={onFilter}
      className="custom-list-search"
    />
  </>
);

function CustomList(props) {

  const dispatch = useDispatch();
  const { getSavedFilters, updateSessionFilters } = useSessionFilters();

  const currentFunctionality = VerifyPermission();
  const defaultPropsForm = {
    type: 'container',
    autoLoadData: props.tabFilters?.length ? false : true,
    canView: props.list.canView ? props.list.canView : currentFunctionality.canView || false,
    canEdit: props.list.canEdit ? props.list.canEdit : currentFunctionality.canEdit || false,
    canDelete: props.list.canDelete ? props.list.canDelete : currentFunctionality.canDelete || false,
    canAdd: props.list.canAdd ? props.list.canAdd : currentFunctionality.canAdd || false,
    viewActionColumn: props.list.viewActionColumn || true,
    key_data_rows: `custom_list_data_${props.list.endpoint}`,
    key_force_update: `force_update_${props.list.endpoint}`,
    pathEdit: '',
    pathView: '',
    pathDelete: '',
    filter: {},
    tabFilters: [],
    fieldsShowOnDelete: [],
    showPrintButtons: false,
    columns: [],
    truncateTextSize: props.list.truncateTextSize || 100,
    columnsButtons: [],
    customStyles: props.list.customStyles || {},
    tabType: props.list.tabType || 'tabs',
    cloneButton: {
      fieldsToShowOnClone: [],
      columnForCloneName: '',
      showCloneButton: false
    },
    order: [
      [props.list.columns[0].name, 'ASC']
    ],
    rows: [],
    intervalRefresh: 0,
    handleConfirmDelete: (item) => { return false },
    formToModal: ''
  }

  const list = { ...defaultPropsForm, ...props.list };

  const shouldLoadSavedState = list.saveState

  let paginationConfigs = {
    current_pagination: 1,
    row_per_page: list.rows_per_page || 10
  }

  if (shouldLoadSavedState) {
    const { current_pagination, row_per_page } = getSavedFilters()

    paginationConfigs = {
      current_pagination: current_pagination || paginationConfigs.current_pagination,
      row_per_page: row_per_page || paginationConfigs.row_per_page
    }
  }

  const [currentPage, setCurrentPage] = useState(paginationConfigs.current_pagination);
  const [paginationPerPage, setPaginationPerPage] = useState(paginationConfigs.row_per_page);

  const navigate = useNavigate();

  const [tabValues, setTabValues] = useState();
  const [formFiltersState, setFormFiltersState] = useState(<></>);

  const [filterText, setFilterText] = React.useState('');
  const [resetPaginationToggle, setResetPaginationToggle] = React.useState(false);

  let [showModal, setShowModal] = useState(false);
  let [isDialogEdit, setIsDialogEdit] = useState(false)
  let [modalTitle, setModalTitle] = useState('');
  let [modalItem, setModalItem] = useState({});
  let [canDelete, setCanDelete] = useState(false);
  const [handleConfirm, setHandleConfirm] = useState('');
  const [classModal, setClassModal] = useState('');
  let [columns, setColumns] = useState([]);
  let [showModalActionButtons, setShowModalActionButtons] = useState(canDelete ? false : !isDialogEdit);
  

  const customListReload = useSelector((state) => { return state.core.session.custom_list_reload ? state.core.session.custom_list_reload : '' });
  const modalContent = useSelector((state) => { return state.core.session.custom_form_content_modal });
  const rows = useSelector((state) => { return state.core.session[list.key_data_rows] ? state.core.session[list.key_data_rows] : [] });
  const selectorCurrentForm = useSelector((state) => { return state.core.session.current_form_values ? state.core.session.current_form_values : {} });
  const selectorCustomTabValues = useSelector((state) => { return state.core.session.custom_tab_values ? state.core.session.custom_tab_values : {} });
  const [index, setIndex] = useState(0);
  let interval = false;

  useEffect(() => {
    if (list.autoLoadData) {
      dispatch({ type: 'UPDATE_SESSION', key: 'custom_list_reload', value: new Date() });
    }
    if (props.list.endpoint) {
      if (list.intervalRefresh) {
        interval = setInterval(async () => {
          dispatch({ type: 'UPDATE_SESSION', key: 'custom_list_reload', value: new Date() });
        }, list.intervalRefresh * 1000)
      }
    }

    if (shouldLoadSavedState) {
      getPaginationSavedSate();
    }

    return () => {
      clearInterval(interval);
      dispatch({ type: 'UPDATE_SESSION', key: 'custom_list_filter', value: {} });
      dispatch({ type: 'UPDATE_SESSION', key: 'update_custom_form_list', value: '' });
      dispatch({ type: 'UPDATE_SESSION', key: 'custom_list_reload', value: '' });  
      dispatch({ type: 'UPDATE_SESSION', key: list.key_data_rows, value: []});  
    };
  }, []);

  useEffect(() => {
    let filters = {}
    dispatch({ type: 'UPDATE_SESSION', key: 'current_form_values', value: {}});
    dispatch({ type: 'UPDATE_SESSION', key: 'custom_tab_values', value:{}});
    setIndex(index+1)
  
    if (customListReload && index > 0) {
      const load = async () => {
        if (shouldLoadSavedState) {
          const savedFilters = getSavedFilters();
          dispatch({ type: 'UPDATE_SESSION', key: 'current_form_values', value: savedFilters.filters});
          filters = { ...savedFilters.filters, ...selectorCustomTabValues }
          await sleep(100);
        }
        if (!list.shouldEmptyList) {
          dispatch({ type: 'UPDATE_SESSION', key: list.key_data_rows, value: [] });
        }
        await loadData(filters);
      }
      load();
    }

  }, [customListReload]);

  const getPaginationSavedSate = () => {
    const { current_pagination, row_per_page } = getSavedFilters()

    if (current_pagination) {
      setCurrentPage(current_pagination)
    }

    if (row_per_page) {
      setPaginationPerPage(row_per_page)
    }

  }

  const onCloneRegistry = async (element, data) => {
    setClassModal('');
    const content = <div>
      <p>Deseja realmente clonar o item:</p>
      {
        list.cloneButton.fieldsToShowOnClone.map(item => <p>
          {data[item]}
        </p>)
      }
    </div>;

    setHandleConfirm('clone');
    setShowModal(true);
    setModalTitle('Clonar registro');
    setModalContent(content);
    setModalItem(data);

  }

  const onCloneRegistryConfirm = async () => {

    dispatch({ type: 'SHOW_LOADING', value: true });
    let response = await Fetch.post(list.endpointClone, { id: modalItem.id, columnForCloneName: list.cloneButton.columnForCloneName ? list.cloneButton.columnForCloneName : '' })
    dispatch({ type: 'SHOW_LOADING', value: false });
    if (response.status == 1) {
      Toast.success('Clonagem realizada com sucesso!');
      loadData({ ...selectorCurrentForm, ...selectorCustomTabValues });
    } else {
      if (response.message && response.message != '') {
        Toast.error(response.message);
      } else {
        Toast.error(
          `Não foi possível realizar a clonagem. 
            Favor entrar em contato com o suporte técnico.`
        );
      }

    }

    setShowModal(false);

  }

  const loadData = async (preparedValues) => {
    let defaultRows = [];
    let percentual = (100 / (list.columns.length + list.columnsButtons.length + 1)) + 2;
    let defaultColumns = [];
  
    for (const item of list.columns) {
      defaultColumns.push({
        name: item.label,
        selector: row => row[item.name],
        editable: !!item.editable,
        maxLength: item.maxLength ? item.maxLength : "",
        minWidth: item.minWidth ? item.minWidth : "",
        editableCallback: item.editableCallback,
        endpointSave: item.endpointSave || '',
        optionsEndpoint: item.optionsEndpoint,
        column: item.name,
        sortable: item.sortable ?? true,
        width: item.width ? item.width : percentual + '%',
        conditionalCellStyles: item.conditionalCellStyles ? item.conditionalCellStyles : {},
        cell: item.cell ? item.cell : undefined,
        tooltip: item.tooltip,
        options: item.options,
        type: item.type,
        isClearable: item.isClearable
      })
    }
  
    {
      list.cloneButton.showCloneButton && defaultColumns.push({
        name: 'Clonar registro',
        selector: row => row.button_clone,
        width: '10%',
        label: 'Clonar Registro',
        icon: 'fas fa-copy',
      })
    }
  
    for await (const buttons of list.columnsButtons) {
      for await (const button of buttons.buttons) {
        let minHeight = 0;
        if (button.type === 'listButton') {
          defaultColumns.push({
            name: button.label,
            cell: row => row[button.label],
            allowOverflow: true,
            column: button.name,
            width: button.width ? button.width : percentual + '%'
          });
          minHeight = button.showActionButtons ? 102 : 0;
          minHeight += button.showCloneButton ? 34 : 0;
          minHeight += list.canDownload ? 34 : 0;
          if (button.buttons) {
            button.buttons.map(buttonDrop => {
              minHeight += 32;
            })
  
          }
          let rdt_Table = document.getElementsByClassName('rdt_Table');
          rdt_Table[0].style.minHeight = `${minHeight}px`;
        } else {
          defaultColumns.push({
            name: button.label,
            selector: row => row[button.label],
            column: button.name,
            width: button.width ? button.width : percentual + '%'
          });
        }
      }
      
    }
  
    if (list.viewActionColumn) {
      defaultColumns.push({
        name: 'Ações',
        selector: row => row.button_actions
      },
    );
    } else {
      defaultColumns.push({
        name: '',
        selector: null
      },
    );
    }
  
    if (props.list.endpoint) {
      let index = 0;

      const defaultFilters = { ...preparedValues, ...list.filter };
  
      const newRows = await Fetch.post(props.list.endpoint, {
        filter: list.filter,
        filters: defaultFilters,
        order: list.order
      });
  
      for await (const item of newRows) {

        for await (const column of list.columns) {
          const isTooltipConditional = column?.tooltip?.tooltipConditional && column?.tooltip?.tooltipConditional(item);
  
          if (isTooltipConditional) {
            if (column.tooltip && column.tooltip.columnValue) {
              const description = isTooltipConditional?.description;
  
              let tooltip = {
                ...column.tooltip,
                description: description ? description : column.tooltip.description
              }
  
              const tooltipContent = (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span style={{ marginRight: '4px' }}>{item[column.name]}</span>
                  <CustomTooltipColumn value={item[column.name]} tooltip={tooltip} />
                </div>
              );
              item[column.name] = tooltipContent;
            }
          }
        }
  
        for await (const buttons of list.columnsButtons) {
          for await (const button of buttons.buttons) {
            let hideButtonRule = false;

            switch (button.type) {
              case 'checkbox':
                let checked = item[button.fieldValue] && item[button.fieldValue] == '1' ? true : false;
  
                if (button.isChecked) {
                  checked = button.isChecked(item);
                }
                
                if (button.hideCustomButton) {
                  const result = await button.hideCustomButton(item);
                  hideButtonRule = result;
                  if (hideButtonRule) {
                    defaultColumns = defaultColumns.filter((column) => column.name !== button.label)
                  }
                };
  
                newRows[index][button.label] = (
                  <CustomCheckBox
                    name={item.name || button.label}
                    onChange={(element) => { button.onChange(element, item) }}
                    checked={checked}
                    switch={false}
                    style={button.style || {}}
                  />
                )
                break;
              case 'switch':
                newRows[index][button.label] = (
                  <CustomCheckBox
                    name={item.name}
                    onChange={(element) => { button.onChange(element, item) }}
                    checked={item[button.fieldValue] && item[button.fieldValue] == '1' ? true : false}
                    switch={true}
                    disabled={button?.disabled || false}
                  />
                )
                break;
              case 'conditional':
                newRows[index][button.label] = button.conditionToDisplaySwitch(item)
                  ? (
                    <CustomCheckBox
                      name={item.name}
                      onChange={(element) => { button.onChange(element, item) }}
                      checked={item[button.fieldValue] && item[button.fieldValue] == '1' ? true : false}
                      switch={true}
                    />
                  )
                  : <span>{button.altText}</span>;
                break;
              case 'listButton':
                const { button_actions, button_clone, Ações, ...columnItem } = item;
                newRows[index][button.label] = (
                  <CustomListButton columnItem={columnItem} item={button} onClickEdit={() => onClickEdit(item)} onClickView={() => onClickView(item)} onDelete={() => onDelete(item)} onCloneRegistry={() => onCloneRegistry('', item)} list={list} showActionButtons={button.showActionButtons} linkToDownload={(list.canDownload && list.fieldToDownload) ? item[list.fieldToDownload] + '' : ''} data={JSON.stringify(item)} />
                )
                break;
              default:
                let disabledButtonRule = false;
                let classname = "btn btn-primary btn-sm btn-action"
  
                if (button.disabledButtonRule) {
                  const result = await button.disabledButtonRule(item);
                  disabledButtonRule = result;
                };
  
                if (button.className) {
                  classname = button.className;
                };
  
                if (button.hideCustomButton) {
                  const result = await button.hideCustomButton(item);
                  hideButtonRule = result;
                  if (hideButtonRule) {
                    defaultColumns = defaultColumns.filter((column) => column.name !== button.label)
                  }
                };
  
                newRows[index][button.label] = !hideButtonRule
                  && (
                    <>
                      <a
                        onClick={() => { button.onClick(item) }}
                        className={`${classname} ${disabledButtonRule && 'disabled-column-button'}`}
                        data-tip
                        data-for="registerTip">
                        {button.icon ? <i className={button.icon} /> : button.label}
                      </a>
                    </>
                  )
                break;
            }
          }
        }
  
        let downloadData = '';
  
        if (list.canDownload && list.fieldToDownload) {
          downloadData = item[list.fieldToDownload] + ''
        }
  
        newRows[index].button_actions = (
          <>
            {(list.canDownload && downloadData && downloadData != "" && (item.canDownload || item.canDownload === undefined)) && (
              <>
                <a
                  className="btn btn-dark btn-sm btn-action"
                  href={`${!downloadData.includes('http') ? config.endpoints.backend : ''}${downloadData}`}
                  download={true}
                  target="_blank"
                  data-tip data-for={"tooltip-download-" + item.id}
                  data-testid={`download-${item[list.columns[0].name]}`} rel="noreferrer"
                >
                  <i className="fas fa-download">

                  </i>
                </a>
                <ReactTooltip id={"tooltip-download-" + item.id} place="top" effect="solid">
                  Download
                </ReactTooltip>
              </>
            )}
            {(list.canDownload && (downloadData == "" || !downloadData) && (item.canDownload || item.canDownload === undefined)) && (
              <>
                <button
                  className="btn btn-secondary btn-sm btn-action"
                  data-tip data-for={"tooltip-notdownload-" + item.id}
                  data-testid={`notdownload-${item[list.columns[0].name]}`}
                  disabled={true}
                >
                  <i className="fas fa-download">
                  </i>
                </button>
                <ReactTooltip id={"tooltip-notdownload-" + item.id} place="top" effect="solid">
                  Sem arquivo
                </ReactTooltip>
              </>
            )}
            {(list.canView && (item.canView || item.canView === undefined) && !!list.formToModal) && (
              <>
                <a
                  className="btn btn-primary btn-sm btn-action"
                  onClick={() => onClickViewModal(item)}
                  data-tip data-for={"tooltip-view-" + item.id}
                >
                  <i className="fas fa-eye"></i>
                </a>
                <ReactTooltip id={"tooltip-view-" + item.id} place="top" effect="solid">
                  Visualizar
                </ReactTooltip>
              </>
            )}
            {(list.canView && (item.canView || item.canView === undefined)) && (
              <>
                <a
                  className="btn btn-primary btn-sm btn-action"
                  onClick={() => onClickView(item)}
                  data-tip data-for={"tooltip-view-" + item.id}
                >
                  <i className="fas fa-magnifying-glass"></i>
                </a>
                <ReactTooltip id={"tooltip-view-" + item.id} place="top" effect="solid">
                  Visualizar
                </ReactTooltip>
              </>
            )}
            {(list.canEdit && (item.canEdit || item.canEdit === undefined) && (props.list.canEditRow === undefined || props.list.canEditRow(item))) && (
              <>
                <a
                  className="btn btn-info btn-sm btn-action"
                  onClick={() => onClickEdit(item)}
                  data-tip data-for={"tooltip-edit-" + item.id}
                  data-testid={`editar-${item[list.columns[0].name]}`}
                >
                  <i className="fas fa-pencil-alt">
                  </i>
                </a>
                <ReactTooltip id={"tooltip-edit-" + item.id} place="top" effect="solid">
                  Editar
                </ReactTooltip>
              </>
            )}
            {(list.canDelete && (item.canDelete || item.canDelete === undefined) && (props.list.canDeleteRow === undefined || props.list.canDeleteRow(item))) && (
              <>
                <a
                  className="btn btn-danger btn-sm btn-action"
                  onClick={() => { onDelete(item) }}
                  data-tip data-for={"tooltip-delete-" + item.id}
                  data-testid={`excluir-${item[list.columns[0].name]}`}
                >
                  <i className="fas fa-trash">
                  </i>
                </a>
                <ReactTooltip id={"tooltip-delete-" + item.id} place="top" effect="solid">
                  Excluir
                </ReactTooltip>
              </>
            )}
          </>
        );
  
        newRows[index].button_clone = (
          <>
            {list.cloneButton.showCloneButton && (
              <>
                <a
                  className="btn btn-primary btn-sm btn-action"
                  onClick={(element) => { onCloneRegistry(element, item) }}
                  data-tip data-for={"tooltip-clone-" + item.id}
                >
                  <i className="fas fa-copy">
                  </i>
                </a>
                <ReactTooltip id={"tooltip-clone-" + item.id} place="top" effect="solid">
                  Clonar registro
                </ReactTooltip>
              </>
            )}
          </>
        );
  
        index++;
      }
  
      defaultColumns.map((column) => {
        const isTooltip = !!(column?.tooltip);
        const isEditable = !!(column?.editable);
        const isTooltipColumn = !!(column?.tooltip?.column);
  
        if (isTooltip && !isEditable && isTooltipColumn) {
          const { name, tooltip } = column;
  
          column.name = <CustomTooltipColumn name={name} tooltip={tooltip} />;
        }
  
        if (isEditable) {
          const { name, column: columnName, maxLength, tooltip, endpointSave, options, optionsEndpoint, type, isClearable, minWidth } = column;
  
          const callback = column.editableCallback;
  
          newRows.map((row, i) => {
            if (row[columnName]) {
              const rowNumber = i;
              const defaultValue = row[columnName];
              const rowInformation = JSON.stringify(row, (key, value) => {
                if (React.isValidElement(value) || key === 'richtext') {
                  return undefined;
                }
  
                return value;
              });
  
              if (type === "select") {
                row[columnName] = (
                  <RowSelect
                    name={name}
                    minWidth={minWidth}
                    index={rowNumber}
                    value={defaultValue}
                    onChange={callback}
                    endpointSave={endpointSave}
                    optionsEndpoint={optionsEndpoint}
                    options={options}
                    item={rowInformation}
                    isClearable={isClearable}
                    column={column}
                  />
                )
              } else {
                row[columnName] = (
                  <EditableInput
                    name={name}
                    type="text"
                    index={rowNumber}
                    onChange={callback}
                    value={defaultValue}
                    maxLength={maxLength}
                    item={rowInformation}
                    endpointSave={endpointSave}
                    column={column}
                  />
                )
              }
            }
  
            return row;
          });
  
          column.name = <CustomTooltipColumn name={name} tooltip={tooltip} isEditable />;
  
        };
      })
  
      setColumns(defaultColumns);
      setRows([...list.rows, ...newRows]);
    } else {
      setColumns(defaultColumns);
      setRows(list.rows);
    }
  
    dispatch({ type: 'UPDATE_SESSION', key: 'custom_list_reloaded', value: new Date() });
  }

  const onDelete = async (element) => {
    setClassModal('');
    let content = <div>
      <p>Deseja realmente excluir o item:</p>
      {
        list.fieldsShowOnDelete.map(item => <p>
          {element[item]}
        </p>)
      }
    </div>;

    if (list.onDelete) {
      let onDeleteResponse = await list.onDelete(element);
      if (onDeleteResponse.content !== undefined && onDeleteResponse.content !== '') {
        content = onDeleteResponse.content;
        if (onDeleteResponse.canDelete === true) {
          setCanDelete(onDeleteResponse.canDelete);
        }
      } else {
        setCanDelete(onDeleteResponse.canDelete);
      }
    }

    setHandleConfirm('delete');
    setShowModal(true);
    setModalTitle('Confirmação de exclusão');
    setModalContent(content);
    setModalItem(element);

  }

  const onDeleteConfirm = async () => {
    if (!list.handleConfirmDelete(modalItem)) {
      dispatch({ type: 'SHOW_LOADING', value: true });
      let response = await Fetch.delete(list.endpointDelete, { id: modalItem.id });
      dispatch({ type: 'SHOW_LOADING', value: false });
      if (response.status == 1) {
        Toast.success('Exclusão realizada com sucesso!');
        dispatch({ type: 'UPDATE_SESSION', key: 'custom_list_reload', value: new Date() });
      } else {
        if (response.message && response.message != '') {
          Toast.error(response.message);
        } else {
          Toast.error(
            `Não foi possível realizar a exclusão. 
             Favor entrar em contato com o suporte técnico.`
          );
        }

      }
    }
    setShowModal(false);
    dispatch({ type: 'UPDATE_SESSION', key: 'custom_list_reload', value: new Date() });
  }

  const closeModal = () => {
    setShowModal(false);
  }

  const onClickEdit = item => {
    let form = props.list.form;
    const list = props.list;
    if (list.type == 'dialog') {
      dispatch({ type: 'UPDATE_SESSION', key: 'custom_form_show_modal', value: true });
      if (list.customEditContent) {
        const closeModal = () => {
          dispatch({ type: 'UPDATE_SESSION', key: 'custom_form_show_modal', value: false });
          dispatch({ type: 'UPDATE_SESSION', key: 'custom_list_reload', value: new Date() });
        }

        setModalContent(list.customEditContent(item, closeModal))
      } else {
        setIsDialogEdit(true)
        const params = {
          id: item.id,
          readOnly: false,
          labelTitle: form.labelTitleEdit,
          key_data_rows: list.key_data_rows
        }
        form = { ...form, ...params };
        form.loadList = loadData;

        setModalContent(<CustomFormContainer
          form={form}
          list={list}
          content={<CustomForm form={form} list={list} />}
        />);
      }

    } else {
      navigate(list.pathEdit + '/' + item.id);
    }
  }

  const onClickView = item => {
    if (list.type === 'dialog') {
      let form = props.list.form;
      const list = props.list;
      dispatch({ type: 'UPDATE_SESSION', key: 'custom_form_show_modal', value: true });
      if (list.customViewContent) {
        const closeModal = () => {
          dispatch({ type: 'UPDATE_SESSION', key: 'custom_form_show_modal', value: false });
        }

        setModalContent(list.customViewContent(item, closeModal))
      } else {
        const params = {
          id: item.id,
          readOnly: true,
          labelTitle: form.labelTitleView,
          showSubmitButton: false,
          isDialogView: true
        }
        form = { ...form, ...params };
        setModalContent(
          <CustomFormContainer
            form={form}
            list={list}
            content={<CustomForm form={form} list={list} />}
          />
        );
      }
    } else {
      navigate(list.pathView + '/' + item.id);
    }
  }

  const onClickViewModal = item => {
    let form = list.formToModal;

    const params = {
      id: item.id,
      readOnly: true,
      labelTitle: form.labelTitleModal,
      showSubmitButton: false,
      showGoBackButton: false,
      isDialogView: true,
      containerType:'dialog'
    }
    form = { ...form, ...params };
    setClassModal('modal-xl');
    setModalTitle('Visualizar');
    setShowModalActionButtons(false);
    setModalContent(
      <CustomFormContainer
        form={form}
        list={list}
        content={<CustomForm form={form} list={list} />}
      />
    );


    setShowModal(true);
  }
  const setModalContent = content => {
    dispatch({ type: 'UPDATE_SESSION', key: 'custom_form_content_modal', value: content });
  }

  const setRows = content => {
    dispatch({ type: 'UPDATE_SESSION', key: list.key_data_rows, value: content });
  }

  const filteredItems = rows.filter(
    item => item && JSON.stringify(item).toLowerCase().includes(filterText.toLowerCase())
  ).map(item => {
    const truncatedItem = {};
    Object.keys(item).forEach(key => {
      truncatedItem[key] = truncate(item[key], list.truncateTextSize);
    });
    return truncatedItem;
  });

  const subHeaderComponentMemo = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText('');
      }
    };

    return (
      <FilterComponent onFilter={e => setFilterText(e.target.value)} onClear={handleClear} filterText={filterText} />
    );
  }, [filterText, resetPaginationToggle]);

  const loadFormFilters = () => {
    if (shouldLoadSavedState) {
      const defaultFilters = props.list.formFilters?.values

      const savedFilters = { ...defaultFilters, ...getSavedFilters().filters }

      return {
        ...props.list.formFilters, values: {
          ...props.list.formFilters?.values,
          ...savedFilters
        }
      }
    } else {

      return { ...props.list.formFilters }
    }
  }

  const customLoadData = async (preparedValues, loadData, tabValue) => {
    const values = { ...preparedValues, ...tabValue};
    await sleep(500);
    if (shouldLoadSavedState) {
      updateSessionFilters({
        filters: values,
      })
    }
    loadData(values)
  }

  function getFormFilters(tabValue) {
    const filters = loadFormFilters();

    const handleSubmit = async (fields, preparedValues) =>  await customLoadData(preparedValues, loadData, tabValue);

    let formFilters = {
      ...filters,
      handleSubmit,
       afterReset: async () => {
        await sleep(100)
        dispatch({ type: 'UPDATE_SESSION', key: 'custom_list_reload', value: new Date() });
        dispatch({ type: 'UPDATE_SESSION', key: 'custom_list_filter_reset', value: new Date() });
      } 
    };

    return formFilters;
  }

  useEffect(() => {
    const loadingContainerStyle = {
      padding: "24px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "16px",
      height: "150px",
      width: "100%",
    }

    const filters = getFormFilters(tabValues);

    const load = async () => {
      setFormFiltersState(
        <div style={loadingContainerStyle}>
          <span clasName="text-primary">Carregando informações...</span>
          <div className="spinner-border ms-auto text-primary" role="status" aria-hidden="true" />
        </div>
      );

      await sleep(300);

      setFormFiltersState(<CustomForm form={filters} key={filters.update_key || ''} />);
      
      if (!props.list.formFilters?.update_key) {
        await sleep(500);
        dispatch({ type: 'UPDATE_SESSION', key: 'custom_list_reload', value: new Date() });
      }
    }
    
    load();
  },[tabValues, props.list.formFilters?.update_key]);

  columns.map((value, index) => {

    if (value.sortable) {
      value.sortFunction = (rowA, rowB) => {
        const cellA = extractCellContent(rowA[value.column]);
        const cellB = extractCellContent(rowB[value.column]);

        return compareCells(cellA, cellB);
      };
    }
    function extractCellContent(cell) {
      if (typeof cell === "string") {
        const date = moment(cell.trim(), "DD/MM/YYYY HH:mm");
        if (date.isValid()) { 
          return date.toDate(); 
        }
        return cell.toLowerCase();
      } else if (typeof cell === "object" && cell?.props && cell?.props?.children) {
        return extractCellContent(cell.props.children[0]);
      } else {
        return "";
      }
    }
    function compareCells(cellA, cellB) {
      if (cellA instanceof Date && cellB instanceof Date) {
        return cellA.getTime() - cellB.getTime();
      } else if (typeof cellA === "string" && typeof cellB === "string") {
        if (cellA > cellB) {
          return 1;
        } else if (cellB > cellA) {
          return -1;
        } else {
          return 0;
        }
      }
    }

    return value;
  });

  const handleModalClose = () => {
    setShowModal(false)
    if (isDialogEdit) setIsDialogEdit(false)
    setShowModalActionButtons(canDelete ? false : !isDialogEdit);
  }

  return (
    <>
      <Modal
        modalXXL={classModal}
        show={showModal}
        handleShow={() => setShowModal(true)}
        handleClose={handleModalClose}
        handleConfirm={handleConfirm === 'delete' ? onDeleteConfirm : onCloneRegistryConfirm}
        handleCancel={closeModal}
        title={canDelete === true ? 'Exclusão não permitida' : modalTitle}
        content={modalContent}
        showButtons={showModalActionButtons}
        showHeader={!isDialogEdit}
      />
      {props.list.customHeader}
      {props.list.formFilters && formFiltersState}
      {props.list.tabFilters && <CustomTab tab={props.list.tabFilters} reloadCustomTab={!!props.list.reloadCustomTab} button={props.list.tabButton} tabType={list.tabType} loadData={loadData} shouldLoadSavedState={shouldLoadSavedState} setTabValues={setTabValues} />}
      {props.list.customTabFilters && props.list.customTabFilters()}
      <DataTable
        customStyles={list.customStyles}
        columns={columns}
        data={filteredItems}
        pagination
        paginationResetDefaultPage={resetPaginationToggle}
        subHeader
        subHeaderComponent={subHeaderComponentMemo}
        paginationDefaultPage={currentPage}
        paginationPerPage={paginationPerPage}
        onChangePage={(value) => shouldLoadSavedState && updateSessionFilters({
          current_pagination: value,
        })}
        onChangeRowsPerPage={(value) => shouldLoadSavedState && updateSessionFilters({
          row_per_page: value,
        })}
      />
    </>
  )
}
export default CustomList;